var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unit-list"},[_c('transition-group',{staticClass:"column",attrs:{"name":"slide-up","tag":"ul","appear":""}},_vm._l((_vm.unit.units),function(unit){return _c('UnitCardCleaner',{key:unit.id,attrs:{"unit":unit}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }